export default __webpack_public_path__ + "static/media/Apel.92b6c6bb.png";